<template>
  <div class="article-inline-slider">
    <cx-slider-v2 height="100%" draggable arrowNagv cycling loop @change="handleSlideChange">
      <cx-slider-item v-for="(image, idx) in images" :key="image.src + idx">
        <div class="cx-media--cover" style="height: 100%;">
          <cx-img
            tag='div'
            :key="image.path"
            :imgSrc="image.src"
            :lazyLoad="false"
            class="cx-media__img" 
          >
            <!-- <div class="cx-media__caption cx-t10">{{image.description}}</div> -->
            <!-- <div class="cx-media__caption cx-t20">{{image.title}}</div> -->
          </cx-img>
        </div>
      </cx-slider-item>
    </cx-slider-v2>
  </div>
</template>

<script>
export default {
  name: 'article-inline-slider',
  props: {
    images: {
      type: Array,
      required: true,
    },
    activeIdx: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      currentActiveIdx: 1,
    };
  },
  mounted() {
    this.currentActiveIdx = this.activeIdx;
  },
  beforeDestroy() {
    //
  },
  methods: {
    handleSlideChange() {
      //
    }
  }
}
</script>

<style lang="scss">
.article-inline-slider {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  .cx-media--cover {
    height: 100%;

    .cx-media__img {
      height: 100%;
    }
  }
}
</style>
